
namespace Gamification.Gamification {
    export class ProdottiLivelliColumns {
        static columnsKey = 'Gamification.ProdottiLivelli';
    }
}